module.exports = __webpack_public_path__ + "static/media/shot-full.38ed2590.png";